import React from 'react';
import { Card } from './ui/card';

const ResponsiveCard = ({ 
  children, 
  className = '', 
  padding = 'default',
  ...props 
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3 sm:p-4',
    default: 'p-4 sm:p-6',
    lg: 'p-6 sm:p-8'
  };

  const responsiveClasses = `
    ${paddingClasses[padding]}
    ${className}
  `.trim();

  return (
    <Card className={responsiveClasses} {...props}>
      {children}
    </Card>
  );
};

export default ResponsiveCard;